import useGetAllClientMarketOrdersInfinite from '@/hooks/query/useGetAllClientMarketOrdersInfinite'

import { InstrumentDto } from '@/gen/publicApi'

import { Card } from '@/components/card'
import OrderAmendDialog from '@/components/orderAmendDialog'
import OrderCancelDialog from '@/components/orderCancelDialog'
import OrderSideText from '@/components/orderSideText'
import OrderStateCircle from '@/components/orderStateCircle'
import Spinner from '@/components/spinner'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/table'

interface Props {
    clientCode: string
    marketCode: string
    instrument: InstrumentDto
}

export default function InstrumentOrders({ clientCode, marketCode, instrument }: Props) {
    const { data: orders } = useGetAllClientMarketOrdersInfinite(clientCode, marketCode, instrument.symbol)

    if (!orders) {
        return <Spinner size="sm" absolute navVisible />
    }

    return (
        <Card className="flex-grow" hideOverflow>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>ClOrdId</TableHead>
                        <TableHead>State</TableHead>
                        <TableHead>Side</TableHead>
                        <TableHead>Strat</TableHead>
                        <TableHead>Units</TableHead>
                        <TableHead>Price</TableHead>
                        <TableHead>Filled Units</TableHead>
                        <TableHead>Filled Value</TableHead>
                        <TableHead></TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {orders &&
                        orders.map(order => (
                            <TableRow key={order.clientOrderRef}>
                                <TableCell>{order.clientOrderRef}</TableCell>
                                <TableCell>
                                    <OrderStateCircle className="mr-2" state={order.state} />
                                    {order.state}
                                </TableCell>
                                <TableCell>
                                    <OrderSideText side={order.side} />
                                </TableCell>
                                <TableCell>{order.targetStrategy}</TableCell>
                                <TableCell>{order.units}</TableCell>
                                <TableCell>{order.price}</TableCell>
                                <TableCell>{order.filledUnits}</TableCell>
                                <TableCell>{order.filledValue}</TableCell>
                                <TableCell>
                                    {order.state == 'Open' && (
                                        <>
                                            <OrderAmendDialog order={order} />
                                            <OrderCancelDialog order={order} />
                                        </>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </Card>
    )
}
